import { useEffect, useRef } from 'react';

export const useLastValidValue = <T>(currentValue: T, isValid: boolean | ((value: T) => boolean)): T => {
  const lastValidValueRef = useRef<T>(currentValue);
  const isValidValue = typeof isValid === 'function' ? isValid(currentValue) : isValid;

  useEffect(() => {
    if (isValidValue) {
      lastValidValueRef.current = currentValue;
    }
  }, [currentValue, isValidValue]);

  return isValidValue ? currentValue : lastValidValueRef.current;
};
